import React from 'react';
import { Location } from '../types/location';

interface LocationCardProps {
  location: Location;
  onEdit: (location: Location) => void;
  onDelete: (_id: string) => void;
}

const LocationCard: React.FC<LocationCardProps> = ({ location, onEdit, onDelete }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-gray-900">{location.name}</h3>
        <div className="flex space-x-2">
          <button
            onClick={() => onEdit(location)}
            className="text-blue-600 hover:text-blue-800"
          >
            Edit
          </button>
          <button
            onClick={() => onDelete(location._id)}
            className="text-red-600 hover:text-red-800"
          >
            Delete
          </button>
        </div>
      </div>
      {location.address && (
        <p className="text-gray-600 mb-2">{location.address}</p>
      )}
      <div className="mt-4 space-y-2">
        <p className="text-sm text-gray-600">
          <span className="font-medium">Staff per shift:</span> {location.shiftStaffCount}
        </p>
        {location.contractType && (
          <div className="mt-2 text-sm text-gray-600">
            <span className="font-medium">Contract Type:</span> {location.contractType}
          </div>
        )}
        <p className="text-sm text-gray-600">
          <span className="font-medium">Created:</span>{' '}
          {new Date(location.createdAt).toLocaleDateString()}
        </p>
      </div>
    </div>
  );
};

export default LocationCard;
